import { useFormikContext } from 'formik';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';
import { RightArrowIcon, DownArrowIcon } from '@td/ui';

import FieldUtil from '../utils/FieldNames';
import {
  accumRulesWithoutEmpty,
  specialtyWithoutEmpty
} from '../utils/convert-to-db';

const defaultArrowProps = {
  width:  12,
  height: 12,
  fill:   '#7C7D74'
};

export const twoSeventyOneKeys = FieldUtil.twoSeventyOneKeys;

const TwoSeventyOneHeader = ({
  visibleSection,
  updateVisibleSection,
  updateTwoSeventyOneVisibleSection
}) => {
  const { values: config } = useFormikContext();

  const accumsMap = useMemo(() => {
    const map = {};
    const keyHash = _.chain(
      _.get(config, 'payer_config.payer_config_settings.two_seventy_one', {})
    ).pick(twoSeventyOneKeys).value();

    twoSeventyOneKeys.forEach(key => {
      map[key] = (keyHash[key] ? Object.keys(keyHash[key]) : FieldUtil.getSpecialityAccums(key)).sort();
    });

    return map;
  }, [config]);

  const isTwoSeventyOneKeyVisible = twoSeventyOneKey => {
    const regex = new RegExp(
      `(two_seventy_one\\.${twoSeventyOneKey}\\.)|(two_seventy_one\\.${twoSeventyOneKey}$)`, 'g'
    );
    return !!visibleSection.match(regex);
  };

  const isTwoSeventyOneAccumVisible = (twoSeventyOneKey, accum) =>
    visibleSection === `two_seventy_one.${twoSeventyOneKey}.${accum}`;

  const isSpecialtyEmpty = specialty =>
    _.isEmpty(
      specialtyWithoutEmpty(
        _.get(config, `payer_config.payer_config_settings.two_seventy_one.${specialty}`)
      )
    );

  const isAccumEmpty = (specialty, accum) =>
    _.isEmpty(
      accumRulesWithoutEmpty(
        _.get(config, `payer_config.payer_config_settings.two_seventy_one.${specialty}.${accum}`)
      )
    );

  const renderTwoSeventyOneHeader = ({ twoSeventyOneKey, accum }) => {
    const isKeyOpen = isTwoSeventyOneKeyVisible(twoSeventyOneKey);
    const emptyClass = isSpecialtyEmpty(config, twoSeventyOneKey) ? 'payerConfigNavEmpty' : '';
    const specialityId = twoSeventyOneKey.toLowerCase();

    const onClickHeader = () => {
      if (isKeyOpen) {
        updateVisibleSection('two_seventy_one');
      } else {
        updateTwoSeventyOneVisibleSection(twoSeventyOneKey, accum);
      }
    };

    return (
      <span
        className="specialtyTitleContainer"
        onClick={onClickHeader}
        data-testid={`speciality-${specialityId}`}
      >
        <span className={`specialtyTitle ${emptyClass}`} >
          {twoSeventyOneKey}
        </span>
        <span className="arrowIcon">
          { isKeyOpen ?
            (<DownArrowIcon {...defaultArrowProps} data-testid={`d-arrow-${specialityId}`} />) :
            (<RightArrowIcon {...defaultArrowProps} data-testid={`r-arrow-${specialityId}`} />) }
        </span>
      </span>
    );
  };
  renderTwoSeventyOneHeader.propTypes = {
    twoSeventyOneKey: PropTypes.string,
    accum:            PropTypes.string
  };

  return (
    <Fragment>
      <h3 className="section_default">Two Seventy One</h3>
      {twoSeventyOneKeys.map(twoSeventyOneKey => (
        <div
          className={`specialty-category ${twoSeventyOneKey.toLowerCase()}`}
          key={twoSeventyOneKey}
        >
          {renderTwoSeventyOneHeader({
            twoSeventyOneKey,
            accum: accumsMap[twoSeventyOneKey][0]
          })}
          {isTwoSeventyOneKeyVisible(twoSeventyOneKey)
            && accumsMap[twoSeventyOneKey].map(accum => {
              const accumVisible = isTwoSeventyOneAccumVisible(twoSeventyOneKey, accum)
                ? 'accumVisible' : '';
              const emptyClass = isAccumEmpty(twoSeventyOneKey, accum)
                ? 'payerConfigNavEmpty' : '';
              return (
                <div key={twoSeventyOneKey.concat(accum)} className="accumTitle">
                  <a
                    className={
                      `accumLink ${accumVisible} ${emptyClass}`
                    }
                    onClick={() => updateTwoSeventyOneVisibleSection(twoSeventyOneKey, accum)}
                  >
                    {FieldUtil.transformName(accum)}
                  </a>
                </div>
              );
            })}
        </div>
      ))}
    </Fragment>
  );
};

TwoSeventyOneHeader.propTypes = {
  visibleSection:                    PropTypes.string,
  updateVisibleSection:              PropTypes.func,
  updateTwoSeventyOneVisibleSection: PropTypes.func
};

export default TwoSeventyOneHeader;
